import {
  Condition,
  NumItemsBeingReturnedOption,
} from "@redotech/redo-model/return-flow/condition";
import {
  itemsBeingReturnedCountFromModel,
  validateItemsBeingReturnedCountCondition,
  type ItemsBeingReturnedCountState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ITEMS_BEING_RETURNED_COUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ItemsBeingReturnedCountState>
  >,
): ConditionType<
  ItemsBeingReturnedCountState,
  Condition.ItemsBeingReturnedCount
> => ({
  name: "Number of items being returned",
  description(state) {
    return `Number of items ${state.numItemsOption.toLowerCase()} ${state.numItems}`;
  },
  Details(props: ConditionTypeDetailsProps<ItemsBeingReturnedCountState>) {
    return React.createElement(Details, props);
  },
  empty: { numItemsOption: NumItemsBeingReturnedOption.EQUALS, numItems: "1" },
  fromModel(model) {
    return itemsBeingReturnedCountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ITEMS_BEING_RETURNED_COUNT,
      numItemsOption: state.numItemsOption,
      numItems: +state.numItems,
    };
  },
  valid(state) {
    return validateItemsBeingReturnedCountCondition(state).valid;
  },
});

export { type ItemsBeingReturnedCountState } from "@redotech/redo-model/return-flow/condition-validate";
